'use client'

import { useEffect } from 'react';
import { cioanalytics } from '@/components/layout/CustomerIO';

export function ArticleTracker({ slug }) {
    useEffect(() => {
        // Track when article is loaded
        cioanalytics.track('article_viewed', { slug });

        // Track when user scrolls to bottom (article completed)
        const handleScroll = () => {
            const scrollPosition = window.scrollY + window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;

            // Consider article complete when user has scrolled to 85% of the article
            if (scrollPosition >= documentHeight * 0.85) {
                cioanalytics.track('article_completed', {
                    slug,
                    timestamp: new Date().toISOString()
                });

                // Remove event listener after tracking completion
                window.removeEventListener('scroll', handleScroll);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [slug]);

    return null; // This is a non-visual component
} 